import React from "react";
import { STRING_TIPO_DE_IMAGEN } from "../../utils/const/string-const";
import ImageTypeSelector from "./ImageTypeSelector";
import GalleryRasterUpload from "./GalleryRasterUpload";
import GallerySvgUpload from "./GallerySvgUpload";

export default function ProductGallerySection({
    tipoImagenes,
    imagenes,
    onTipoChange,
    onImagenesChange,
    t,
    disabled = false,
    onBusyChange,
    onError,
}) {
    const selectedTipo = tipoImagenes || STRING_TIPO_DE_IMAGEN.image;

    const handleTipoChange = (nextTipo) => {
        if (nextTipo !== selectedTipo) {
            onImagenesChange([]);
        }
        onTipoChange(nextTipo);
    };

    const galleryList = Array.isArray(imagenes) ? imagenes : [];

    return (
        <section className="rounded-2xl border border-slate-200 bg-white p-4 sm:p-5">
            <h3 className="text-base font-bold text-slate-900 mb-4">{t("label_galeria_imagenes")}</h3>

            <ImageTypeSelector
                label={t("label_tipo_imagenes")}
                value={selectedTipo}
                onChange={handleTipoChange}
                t={t}
                disabled={disabled}
            />

            <div className="mt-4">
                {selectedTipo === STRING_TIPO_DE_IMAGEN.image && (
                    <GalleryRasterUpload
                        images={galleryList}
                        onChange={onImagenesChange}
                        t={t}
                        disabled={disabled}
                        onBusyChange={onBusyChange}
                        onError={onError}
                    />
                )}

                {selectedTipo === STRING_TIPO_DE_IMAGEN.svg && (
                    <GallerySvgUpload
                        images={galleryList}
                        onChange={onImagenesChange}
                        t={t}
                        disabled={disabled}
                        onError={onError}
                    />
                )}
            </div>
        </section>
    );
}
